import { Directive, forwardRef, OnInit, Input, ElementRef, HostListener } from "@angular/core";
import { AbstractControl, ControlValueAccessor, FormGroupDirective, NG_VALUE_ACCESSOR } from "@angular/forms";

import { AttachmentModel } from "../interfaces";
import { AttachmentService } from "../services";

@Directive({
    selector: "input[type=file][controlName]",
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FileFormControlValueAccessor),
        multi: true,
    }],
    standalone: false
})
export class FileFormControlValueAccessor
    implements ControlValueAccessor, OnInit
{
    @Input() readonly controlName: string;
    @Input() readonly multiple: boolean;

    private _onChange: (value: unknown) => void;
    private _onTouched: () => void;

    constructor(
        private readonly elementRef: ElementRef<HTMLInputElement>,
        private readonly formGroupDirective: FormGroupDirective,
        private readonly $attachmentService: AttachmentService)
    { }

    private get formControl(): AbstractControl<Array<AttachmentModel>> { return this.formGroupDirective.form?.get(this.controlName); }

    ngOnInit(): void
    {
        if (!this.formControl)
        {
            throw new Error(`FileFormControlValueAccessor: Cannot determine FormControl`);
        }
    }

    @HostListener("change", ["$event"])
    onChange(): void
    {
        const fileInput = this.elementRef.nativeElement;
        const files = Array.from(fileInput.files);
        this.$attachmentService.ConvertToAttachments(files)
            .then(result =>
            {
                // this.formControl.setValue(result);
                this.fireOnChange(result);

            });
    }

    writeValue(obj: unknown): void
    {
        console.warn(`FileFormControlValueAccessor.writeValue(obj) `, { obj });
        // this.elementRef.nativeElement.value = obj;
    }

    /** @override ControlValueAccessor.registerOnChange */
    registerOnChange(fn: (value: unknown) => void): void
    {
        this._onChange = fn;
    }

    /** @override ControlValueAccessor.registerOnTouched */
    registerOnTouched(fn: () => void): void
    {
        this._onTouched = fn;
    }

    private fireOnChange(value: unknown): void
    {
        if (!this._onChange)
        {
            return;
        }

        this._onChange(value);
    }

    /** @override ControlValueAccessor.setDisabledState */
    setDisabledState?(isDisabled: boolean): void
    {
        this.elementRef.nativeElement.disabled = isDisabled;
    }
}
